export enum componentAvalaible {
  /** Recipients come from the attendee selection (tag lists + copy-manager switch), not free-form emails. */
  choiceDelivery = "choiceDelivery",
  doSendManager = "doSendManager",
  subject = "subject",
  content = "content",
  sendIcs = "sendIcs",
  sendUrlSession = "sendUrlSession",
}

export enum typeNotications {
  session = "session",
}

export enum ActionTypeEnum {
  NOTIFY = "notify",
  SUMMON = "summon",
}
